import React from 'react';
import APIErrorComponent from '.';
import { useSelector } from 'react-redux';
import { detectMobile } from '../../utils/formatting';

type ErrorComponentProps = {
    input: Array<string>;
    isbottomOfDom?:boolean;
    customErrorMsg?: string|null;
};

const ErrorComponent: React.FC<ErrorComponentProps> = ({ input,isbottomOfDom=true,customErrorMsg }) => {
    const isMobile = detectMobile();
    const errors = useSelector((state: any) => state.financialReferralReducer?.APIerrors);
    let isError: boolean = false;
    let errorCount = 0;
    for (let i = 0; i < input?.length; i++) {
        if (errors?.includes(input[i])) {
            isError = true;
            errorCount++;
        }
    }

    if(isError){
        if (isbottomOfDom) {
            return (
                <div>
                  <div className={isMobile ? "error-bottom px-4 mt-4" : "error-bottom absolute px-4"}>
                        <APIErrorComponent errorCount={errorCount} customErrorMsg={customErrorMsg} />
                  </div>
                   
                </div>
            );
        } else {
            return <APIErrorComponent errorCount={errorCount} customErrorMsg={customErrorMsg}/>;
        }
    }else
    return null;
};

export default ErrorComponent;